import { render, staticRenderFns } from "./RequestMgtCloseRequestButton.vue?vue&type=template&id=65e50704&"
import script from "./RequestMgtCloseRequestButton.vue?vue&type=script&lang=js&"
export * from "./RequestMgtCloseRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports